/**
 * @module public/js/core/useTenant.js
 * @summary Lightweight tenant switching helper for super admins.
 */

const sessionKey = 'topsail__tenant';
const localKey = 'activeTenant';

const sessionTenant =
  typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem(sessionKey)
    : null;
const localTenant =
  typeof localStorage !== 'undefined' ? localStorage.getItem(localKey) : null;

let current = sessionTenant || localTenant || null; // ← init on load

if (current && typeof sessionStorage !== 'undefined') {
  sessionStorage.setItem(sessionKey, current);
}

if (current && typeof localStorage !== 'undefined') {
  localStorage.setItem(localKey, current);
}
const subs = new Set();

function notify() {
  subs.forEach((cb) => {
    try {
      cb(current);
    } catch {
      /* noop */
    }
  });
}

export default function useTenant() {
  const get = () => current;

  const set = (id) => {
    if (!id) return;
    current = id;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(localKey, id);
    }
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(sessionKey, id);
    }
    notify();
  };

  const subscribe = (cb) => {
    subs.add(cb);
    cb(get()); // immediate first call
    return () => subs.delete(cb);
  };

  return { getTenantId: get, setTenantId: set, subscribe };
}
